import { render, staticRenderFns } from "./EmployeeBranchInfo.vue?vue&type=template&id=06cbf4c0&scoped=true&"
import script from "./EmployeeBranchInfo.vue?vue&type=script&lang=js&"
export * from "./EmployeeBranchInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cbf4c0",
  null
  
)

export default component.exports